import _ from 'lodash'

export default {
  props: {
    searchFields: {
      type: Array,
      default: function () { return ['first_name', 'last_name'] }
    }
  },
  data: function () {
    return {
      searchBox: ''
    }
  },
  methods: {
    filteredList: function (collection) {
      var self = this
      var lowSearch = self.searchBox.toLowerCase()
      var out
      if (lowSearch.hasOwnProperty('trim')) {
        lowSearch = lowSearch.trim()
      }
      if (lowSearch.length > 1) {
        out = _.filter(collection, function (item) {
          var ss = self.searchStrings[item[self.pk || 'id']]
          return ss && ss.indexOf(lowSearch) > -1 // || false
        })
        return out
      } else {
        return collection
      }
    }
  },
  computed: {
    searchStrings: function () {
      var self = this
      var l = self.searchFields.length
      var val = ''
      var _strings = []
      self.dataset.forEach(function (obj) {
        var s = ''
        var j = 0
        for (;j < l; j++) {
          // create a sortable key which works for numeric bibs
          if (obj.hasOwnProperty('bib') && !obj.hasOwnProperty('sortbib')) {
            obj.sortbib = (isNaN(parseInt(obj.bib)) ? obj.bib : parseInt(obj.bib))
          }
          val = obj[self.searchFields[j]]
          if (typeof (val) === 'string') {
            s += val.toLowerCase() + ' '
          }
        }
        _strings[obj[self.pk]] = s
      })
      return _strings
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/SearchMixin.js